import React, { Component, Fragment } from 'react';
import {stickStr, buttonStr, attackStr,getCancels,getMot,getHitEffects,computeRecovery,hasReq} from './utils'
import ReqList from './ReqList'
import tooltips from './tooltips'
export default class CancelTable extends Component {
  render(){
    var {selectedMot,data,selectedMotId,startIndex,selectMot,options} = this.props;
    if(!data || !selectedMot) return <div>Loading...</div>
    var cancels = getCancels(data,startIndex);
    var hitEffects = getHitEffects(data,selectedMot.hitEffectId)
    var hitEffect = hitEffects[hitEffects.length-1];
    //TODO: not just standing reaction?
    var hitAnimation = data.hitAnimations[hitEffect.hitEffect.hitAnimation][1][0]
    var [reactionFrames, reactionId] = computeRecovery(data,getMot(data,hitAnimation))
    //      //  <td><pre>{JSON.stringify(cancel,null,0)}</pre></td>
    var _this = this;
    function _cancelElement(cancel,i){
      var target;
      if(cancel.motId > 0x7FFF){
        target = data.states[data.aliases[cancel.motId]];
      } else {
        target = data.states[cancel.motId];
      }
      var blackList = [217,254,809,1,356,359,167,559,558,563,811,32769,126,32771];

      if(options.hideItemMoves){
        blackList.push(609)
      }
      if(options.hideBackSideMoves){
        blackList.push(72,80,81)
      }
      if(hasReq(data,cancel.reqId,blackList)){
        return null
      }
      var comboInfo = <div></div>;
      var adv = reactionFrames - cancel.ext + selectedMot.startup - target.startup;
      var atkinfo = <span className="flag">{attackStr(target.attackFlags)} S:{target.startup}</span>;
      if(selectedMot.startup == 0){
        if(target.startup  != 0){
          comboInfo = atkinfo
        }

      } else if(cancel.ext < selectedMot.startup){
        comboInfo = <Fragment><span className="flag">Kara</span> {atkinfo}</Fragment>
      }
      else if(target.startup == 0){
        if(adv > 0){
          comboInfo = <span className="flag success">+{adv}</span>
        } else {
          comboInfo = <span className="flag failure">{adv}</span>
        }
      } else {

        if(adv > 0){
          comboInfo = <Fragment><span className="flag success"><i class="fas fa-check"></i>+{adv}</span> {atkinfo}</Fragment>
        } else {
          comboInfo = <Fragment><span className="flag warning"><i class="fas fa-minus"></i>:{adv} </span> {atkinfo}</Fragment>
        }

      }
      return <tr key={i}>
        <td>{comboInfo}</td>
        <td>{cancel.inputStart}->{cancel.inputEnd == 32767 ? "*" : cancel.inputEnd}@{cancel.ext == 32767 ? "*" :cancel.ext}</td>

        <td>{stickStr(cancel.target)} {buttonStr(cancel.button)}</td>
        <td><a onClick={()=> selectMot(cancel.motId)}>#{cancel.motId.toString(16)} {target.name}</a></td>
        <td><ReqList {..._this.props} startIndex={cancel.reqId}/></td>
      </tr>
    }
    return <table className="CancelTable compactTable u-full-width">
      <thead>
        <tr><th colSpan="5" className="alt">Cancel Info <i data-tip={tooltips.cancelInfo} className="fas fa-question-circle tip"></i></th></tr>
        <tr><th></th><th>Window</th><th>-></th><th>Attack?</th><th>Requirements</th></tr>
      </thead>
      <tbody>{cancels.map(_cancelElement)}</tbody>
    </table>
  }
}



// WEBPACK FOOTER //
// ./src/CancelTable.js